// "Race the Ghost" reward: if you beat today's daily champion (score AND
// survival time), you get +1 life next run. Client-only via localStorage.
const KEY = "ppe_extra_life_v1";

export function hasExtraLife() {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function grantExtraLife() {
  try {
    localStorage.setItem(KEY, "1");
  } catch {}
}

// Consume the bonus so it's only applied once. Call this AFTER createGameState
// has read the flag and awarded the extra life.
export function consumeExtraLife() {
  try {
    localStorage.removeItem(KEY);
  } catch {}
}

// Did the run beat the ghost? Score must be strictly greater; survival time as tiebreaker.
export function didBeatGhost(playerScore, playerTime, ghost) {
  if (!ghost) return false;
  const ghostScore = Number(ghost.score) || 0;
  const ghostTime = Number(ghost.survival_time) || 0;
  if (playerScore > ghostScore) return true;
  if (playerScore === ghostScore && playerTime > ghostTime) return true;
  return false;
}
